import { render, staticRenderFns } from "./PublicationHabeasData.vue?vue&type=template&id=308086dc&scoped=true"
import script from "./PublicationHabeasData.vue?vue&type=script&lang=js"
export * from "./PublicationHabeasData.vue?vue&type=script&lang=js"
import style0 from "./PublicationHabeasData.vue?vue&type=style&index=0&id=308086dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308086dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308086dc')) {
      api.createRecord('308086dc', component.options)
    } else {
      api.reload('308086dc', component.options)
    }
    module.hot.accept("./PublicationHabeasData.vue?vue&type=template&id=308086dc&scoped=true", function () {
      api.rerender('308086dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/PublicationHabeasData.vue"
export default component.exports